import { useState } from "react";
import { Disc } from "react-feather";
import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { TranslucentToastsTitle } from "../../../../Constants/Constants";
import { TranslucentToastSubTitle } from "../../../../Data/BonusUi/Toasts";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import TranslucentToastsList from "./TranslucentToastsList";

const TranslucentToasts = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card className="overflow-hidden">
        <CommonCardHeader title={TranslucentToastsTitle} span={TranslucentToastSubTitle} />
        <CardBody className="toast-rtl bg-dark">
          <div className="toast-container">
            <Toast isOpen={open}>
              <div className="toast-header">
                <Disc className="toast-icons toast-info" />
                <strong className="me-auto">{"Moscow theme"}</strong>
                <small className="text-muted d-sm-block d-none">{"11 mins ago"}</small>
                <Btn close className="p-0" onClick={() => setOpen(false)}></Btn>
              </div>
              <ToastBody className="toast-dark">{"Hello, I'm a web-designer."}</ToastBody>
            </Toast>
            <TranslucentToastsList />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TranslucentToasts;
